import { render } from "./ReportFiltersSidebar.vue?vue&type=template&id=36f05560&scoped=true"
import script from "./ReportFiltersSidebar.vue?vue&type=script&lang=js"
export * from "./ReportFiltersSidebar.vue?vue&type=script&lang=js"

import "./ReportFiltersSidebar.vue?vue&type=style&index=0&id=36f05560&scoped=true&lang=css"
import "./ReportFiltersSidebar.vue?vue&type=style&index=1&id=36f05560&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f05560"]])

export default __exports__